import {
  computed,
  DestroyRef,
  inject,
  Injectable,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { _HttpClient } from '@delon/theme';

@Injectable({
  providedIn: 'root'
})
export class LicenseUtilsService {
  #http = inject(_HttpClient);
  #licenseUrl = 'api/license/mylicense';
  #destroyRef = inject(DestroyRef);

  license = signal<License | null>(null);

  multiLocationsEnabled = computed(() => this.#moduleEnabled('Multi-Location'));

  planName = computed(() => {
    let planName = this.license()?.plan as string;
    return planMap[planName] || (planName as Plan);
  });

  getLicense() {
    return this.#http
      .get<any>(this.#licenseUrl)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: res => {
          this.license.set(res?.license);
        }
      });
  }

  #moduleEnabled = (moduleName: string) =>
    this.license()?.modules.find(m => m.name === moduleName)?.enabled === true;
}

export interface License {
  accountant: Record<string, any>;
  dealer: Record<string, any>;
  buyer: Record<string, any>;
  productKey: string;
  productName: string;
  plan: string;
  expiryDate: Date | null;
  isSubscription: boolean;
  numberOfCompanies: number;
  numberOfUsers: number;
  concurrentUsers: number;
  concurrentUsersOccupied: number;
  nouOccupied: number;
  numberOfNamedUsers: number;
  nocOccupied: number;
  modules: any[];
}

const planMap: Record<string, Plan> = {
  QCA_PRO: 'PRO',
  'PRO PLAN': 'PRO',
  QCA_ESSENTIAL: 'ESSENTIAL',
  ESSENTIAL: 'ESSENTIAL',
  QCA_LITE: 'LITE',
  LITE: 'LITE',
  QCA_BASIC: 'BASIC',
  BASIC: 'BASIC',
  QCA_EINVOICE: 'Quick E-Invoice',
  'Quick E-Invoice': 'Quick E-Invoice',
  QCA_PRIME: 'PRIME',
  PRIME: 'PRIME',
  QCA_ACCOUNTANT: 'ACCOUNTANT',
  ACCOUNTANT: 'ACCOUNTANT',
  QCA_GROWTH: 'GROWTH',
  GROWTH: 'GROWTH',
  QCA_ENTERPRISE: 'ENTERPRISE',
  ENTERPRISE: 'ENTERPRISE'
};

export type Plan =
  | 'BASIC'
  | 'LITE'
  | 'ESSENTIAL'
  | 'PRO'
  | 'PRIME'
  | 'ACCOUNTANT'
  | 'GROWTH'
  | 'ENTERPRISE'
  | 'Quick E-Invoice'
  | any;
export type Region = 'PH' | 'MY' | 'MM';
